import React, {useEffect} from 'react'
// import {Navigate} from 'react-router-dom'
import {CardActionButton, CardHeader, Card, SignInLayout, PurviewFooter} from '../components/SigninLayout'
import {WithForm, TextInput, Errors, DatePicker} from '@startlibs/form'
import {ExpiredPage} from './errors/ExpiredPage'
import {useSuspense, useTokenSuspense} from '../hooks/useSuspense'
import {urlTokenFormFetch} from '../utils/authFetch'
import _ from 'lodash/fp'
import {useClearSession} from '../hooks/useClearSession'
import {formatDate} from '@startlibs/utils'
import {buildValidation, required, responseFailure} from '../utils/validation'
import {HelpButton} from "../components/HelpButton";
import {SPA_ORIGIN} from './ShareDialog'
import {DATE_FORMAT} from '../utils/DateFormat'
import {LoadingPage} from '../components/PageLoading'
import { Redirect } from '../components/Redirect'

export const ACCESS_ERROR = "Invalid patient data. Please check the fields above and try again."

const transformDoB = (dobSubmitFormat) => _.update('dob',(dob) => {
  return formatDate(dob,dobSubmitFormat).replace(/\//g,'')
})


export const ShareLogin = ({withoutFooter, dobSubmitFormat = 'MM/dd/yyyy', labels = {}, providerInfo,navigate, shareInfo, authenticationResponse,token,successUrl = (token) => '/shared/'+token}) => {

  const expired = false

  useClearSession()
  const [loginSuccess, setLoginSuccess] = React.useState(false)

  const onSuccess = (_,{jwt,...rest}) => {
    window.sessionStorage.setItem('sharejwt',jwt)
    window.sessionStorage.setItem('sharedata',JSON.stringify({...rest,shareStudyReport:shareInfo.sharingOptions.shareStudyReport,allowImageDownload:shareInfo.sharingOptions.allowImageDownload,sharingOptions:shareInfo.sharingOptions}))
    setLoginSuccess(true)
  }

  const onFailure = responseFailure((data,{status})=> status === 401 && {"lastName":ACCESS_ERROR,"dob":ACCESS_ERROR})

  useEffect(() => {
    if (authenticationResponse || loginSuccess) {
      onSuccess('',{...shareInfo,...authenticationResponse})
    }
  },[authenticationResponse])

  if (authenticationResponse || loginSuccess) {
    // return <LoadingPage/>
    // return <Navigate to={successUrl(token)} replace={true} />
    return <Redirect to={successUrl(token)} replace={true} />
  }

  if (expired) {
    return <ExpiredPage providerInfo={providerInfo}/>
  }

  return <SignInLayout withoutFooter={withoutFooter} providerInfo={providerInfo}>
      <Card>
        <CardHeader>
          <h1>{labels.title || "Confirm data to access records"}</h1>
          <p>{labels.subtitle || "Please enter the requested information below to access the shared records"}</p>
        </CardHeader>
        <WithForm
          alwaysSave
          onSuccess={onSuccess}
          transform={transformDoB(dobSubmitFormat)}
          onFailure={onFailure}
          action={urlTokenFormFetch(SPA_ORIGIN() + '/api/share/authenticate')}
        >{form => <>
          {
            shareInfo.phiProtectionAttributes.lastName &&
          <TextInput
            label="Patient last name"
            placeholder="Ex: Smith"
            path="lastName"
          />
          }
          {
            shareInfo.phiProtectionAttributes.dob &&
          <DatePicker
            weekStartsMonday
            label="Patient date of birth"
            placeholder={`Ex: ${DATE_FORMAT(providerInfo.dateFormat).toUpperCase()}`}
            format={DATE_FORMAT(providerInfo.dateFormat)}
            path="dob"
          />
          }
          <Errors/>
          <CardActionButton highlight isLoading={form.isLoading} type="submit">{labels.button || "Access Shared Records"}</CardActionButton>
        </>}</WithForm>
        {!withoutFooter && <PurviewFooter/>}
      </Card>
      <HelpButton />
    </SignInLayout>
}
